package com.milta.feature.team.domain.usecase

import com.milta.feature.team.domain.repository.TeamRepository

/** MIL-53 — permanently deletes the calling Gestionnaire's Organisation. Irreversible. */
class DeleteEnterpriseUseCase(private val repository: TeamRepository) {
    suspend operator fun invoke(): Result<Unit> = repository.deleteMyEnterprise()
}
